module.exports = __webpack_public_path__ + "d46ee5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/feedback/shilo.png
// module id = 3234
// module chunks = 21